module.exports = __webpack_public_path__ + "img/202312_07.00090980.jpg";